<template>
	<div>
		<Header />
		<Carousel v-model="value" loop :height="400" arrow="never" dots="none">
			<CarouselItem>
				<div class="banner"
					:style="{'background': 'url('+require('@/assets/img/tableEntryService/caseBanner.jpg')+') center center no-repeat'}">
					<div>
						<p class="pageType">产品详情</p>
					</div>
				</div>
			</CarouselItem>
		</Carousel>
		<div class="mainContent">
			<Breadcrumb style="margin-bottom: 30px;">
				<BreadcrumbItem to="/">首页</BreadcrumbItem>
				<BreadcrumbItem :to="{path: '/caseLibrary',query:{ index:0, pageNum:this.$route.query.pageNum }}">
					产品列表
				</BreadcrumbItem>
				<BreadcrumbItem>详情</BreadcrumbItem>
			</Breadcrumb>

			<div>
				<ul>
					<li>
						<span>公司名称</span>
						<span>{{baseInfo.orgName}}</span>
					</li>
					<li>
						<span>产品名称</span>
						<span>{{baseInfo.productName}}</span>
					</li>
					<li>
						<span>产品类型</span>
						<span>{{baseInfo.productType}}</span>
					</li>
					<li>
						<span>产品介绍</span>
						<span>{{baseInfo.productIntroduction}}</span>
					</li>
					<li>
						<span>行业</span>
						<span>{{baseInfo.industry+'-'+baseInfo.territory}}</span>
					</li>
					<li>
						<span>应用场景</span>
						<span v-html="baseInfo.restrictionsOnUse"></span>
					</li>
					<li>
						<span>产品关键词</span>
						<span>{{baseInfo.productKeyWords?JSON.parse(baseInfo.productKeyWords.replace(/'/g, '"')).join('、'):''}}</span>
					</li>
					<li>
						<span>售价</span>
						<span>{{baseInfo.unitPrice?baseInfo.unitPrice+'元':''}}</span>
					</li>
					<li>
						<span>销售量</span>
						<span>{{baseInfo.salesNum?baseInfo.salesNum+'次':''}}</span>
					</li>
					<li>
						<span>来源</span>
						<span>{{baseInfo.source}}</span>
					</li>
					<a :href="baseInfo.address" target="_blank" style="font-size: 18px;">{{baseInfo.address}}</a>
				</ul>



			</div>


		</div>


		<SignUp />
		<Footer />
	</div>
</template>

<script>
	import Header from '../../common/header/flow_header.vue'
	import Footer from '../../common/footer.vue'
	import publicMethod from '../publicMethod'
	import SignUp from '@/components/signUp/index.vue'

	import qs from 'qs'
	import axios from 'axios'

	export default {
		mixins: [publicMethod],
		components: {
			Header,
			Footer,
			SignUp
		},
		data() {
			return {
				url: this.domain.testUrl + this.domain.valuationProject,
				value: 0,
				baseInfo: {
					productKeyWords: '[]'
				}

			}
		},
		mounted() {
			this.getDataProductDetail()


		},
		methods: {
			getDataProductDetail(pageNum) {
				this.$post(this.url + 'dataProductExchange/getDataProductDetail', qs.stringify({
						productId: this.$route.query.id ? this.$route.query.id : ''
					}))
					.then(res => {
						this.baseInfo = res.data.content

					})

			}



		}


	}
</script>

<style scoped lang="less">
	.mainContent {
		margin-top: 30px;
	}

	ul {
		padding: 30px 40px;
		box-shadow: 2px 2px 13px 0px rgba(32, 76, 151, 0.23);

		li {
			margin-bottom: 15px;

			span {
				font-size: 18px;
				color: #282828;
				vertical-align: top;
				text-align: justify;
			}

			span:first-child {
				width: 150px;
				font-weight: bold;
			}

			span:last-child {
				width: calc(100% - 150px);
			}

		}
	}
</style>